import React, { useContext } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCheck, faSquare } from '@fortawesome/free-solid-svg-icons'
import { AppContext } from '../App'

export default function NavigationItem(props) {
   const { step, order } = props
   const iconCheck = <FontAwesomeIcon icon={ faCheck } color="#00a8d5" />
   const iconSquare = <FontAwesomeIcon icon={ faSquare } color="#00a8d5" />
   const { stepsCompleted, productOptionsSelected } = useContext(AppContext)
   const { productOptions } = productOptionsSelected
   let productType = productOptions[1]
   let numberStepsCompleted = productOptions.length-1
   let numberResinousStepsCompleted = productOptions.length-2

   return (
      <li className={
         // If this nav item is the current one, render it bold.
         productType==="Resinous Flooring" && order===numberResinousStepsCompleted && step!=="Select Application" ? "bold" : (
            productType!=="Resinous Flooring" && order===numberStepsCompleted ? "bold" : null
         )
      }>
         { iconSquare } { step } { step === "Select Application" || stepsCompleted.indexOf(step) > -1 ? iconCheck : null }
      </li>
   )
}


// WEBPACK FOOTER //
// ./src/components/NavigationItem.js